import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  //width: 100%;
  //margin: 2px;
  padding: 2px;
  //border: 1px solid black;
  font: normal normal 600 11px/12px Open Sans;
  letter-spacing: 0px;
  color: ${({ clicked }) => {
    if (clicked) return "#000000;";
    else return "#707070;";
  }};
  height: 26px;
`;

export const IconWrapper = styled.div`
  height: 100%;
  position: static;
  margin-right: 5px;
  display: flex;
  align-items: center;
  justify-content: start;
  opacity: 1;
  background: transparent 0% 0% no-repeat padding-box;
  color: ${({ clicked }) => {
    if (clicked) return "#FFFFFF;";
    else return "#707070;";
  }};
`;

export const HorizontalSeparator = styled.div`
  border-bottom: 1.5px solid #70707030;
  width: 98%;
  margin: 3px;
`;

export const IconBox = styled.div`
  height: 13px;
  width: 13px;
  background: ${({ backgroundColor }) => {
    return backgroundColor;
  }};
  margin-right: ${({ marginRight }) => {
    return marginRight ? marginRight : "1px";
  }};
  margin-top: ${({ marginTop }) => {
    return marginTop ? marginTop : "1px";
  }};
  opacity: 1;
`;

export const TextWrapper = styled.div`
  text-align: left;
  font: normal normal 600 11px/12px Open Sans;
  letter-spacing: 0px;
  color: ${({ clicked }) => {
    if (clicked) return "#000000;";
    else return "#707070;";
  }};
  opacity: 1;
  align-items: center;
  margin-left: 4px;
  font-weight: ${({ isBold }) => (isBold ? "900" : "normal")};
`;

export const TextWrapper2 = styled.div`
  text-align: left;
  font: normal normal 600 11px/12px Open Sans;
  letter-spacing: 0px;
  color: ${({ clicked }) => {
    if (clicked) return "#000000;";
    else return "#707070;";
  }};
  opacity: 1;
  align-items: left;
  margin-left: 4px;
  font-weight: ${({ isBold }) => (isBold ? "900" : "normal")};
`;

export const LogoWrapper = styled.div`
  display: flex;
  width: ${({ width }) => (width ? width : "100%")};
  height: ${({ height }) => (height ? height : "auto")};
  justify-content: ${({ align }) => {
    return align;
  }};
  align-items: ${({ verticle }) => {
    return verticle ? verticle : "center";
  }};
`;

export const Text = styled.div`
  font-weight: ${({ isBold }) => (isBold ? "900" : "normal")};
`;

export const BottomLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 5px;
  width: ${({ width }) => (width ? width : "auto")};
  height: ${({ height }) => (height ? height : "38px")};
  cursor: pointer;
  border-bottom: ${({ isClicked }) =>
    isClicked ? "1px solid #007842" : "none"};
`;

export const TooltipContentWrapper = styled.div`
  display: flex;
  width: 100%;
  margin: 5px 0px;
`;

export const TooltipKey = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
`;

export const ShortTooltipKey = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 60%;
`;

export const TooltipValue = styled.div`
  display: flex;
  width: 40%;
  justify-content: flex-start;
  text-align: left;
  max-width: 135px;
  word-break: break-all;
`;

export const TooltipValueCus = styled.div`
  display: flex;
  width: 40%;
  justify-content: flex-end;
  text-align: right;
  max-width: 135px;
  word-break: break-all;
  color: #707070;
  font: normal normal normal 12px/17px Open Sans;
`;

export const ShortTooltipKeyCus = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 60%;
  color: #707070;
  font: normal normal normal 12px/19px Open Sans
`;